// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__w8cpv","label":"LabeledBox_label__Obg-7"};